/* eslint-disable radix */
import React, { Component } from 'react';
import ConfiguracoesGeraisPage from './geral.page';
import ConfiguracaoApi from '../../configuracao.api';
import * as commonActions from '../../../../app/common/common.action';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import IntlMessage from '../../../../../src/helpers/intlMessage';

class ConfiguracoesGeraisContainer extends Component {
  constructor () {
    super();
    this.state = {
      switchValor: false,
      posicaoSigla: null,
      posicaoSequencia: null,
      posicaoAno: null,
      valorAno: '',
      posicaoSeparador: null,
      valorSeparador: '',
      posicoesJaSelecionadas: [],
      exemploNumeroExamePersonalizado: [],
      nomeNotas: '',
      ordenacao: [
        {
          value: '0',
          label: <IntlMessage id = "dashboards.general.firstPosition"/>
        },
        {
          value: '1',
          label: <IntlMessage id = "dashboards.general.secondPosition"/>
        },
        {
          value: '2',
          label: <IntlMessage id = "dashboards.general.thirdPosition"/>
        },
        {
          value: '3',
          label: <IntlMessage id = "dashboards.general.fourthPosition"/>
        }
      ],
      imprimirProtocoloEntrega: 'N',
      agruparLaudos: 'N'
    };
  }

  alterarNomeNotas = val => {
    if (/^[A-Z]{0,8}$/i.test(val)) {
      const valor = val.charAt(0).toUpperCase() + val.slice(1);
      this.setState({ nomeNotas: valor });
    } else {
      this.setState({ nomeNotas: this.state.nomeNotas });
    }
  };

  render () {
    let {
      switchValor,
      ordenacao,
      posicaoSigla,
      posicaoSequencia,
      posicaoAno,
      valorAno,
      posicaoSeparador,
      valorSeparador,
      posicoesJaSelecionadas,
      exemploNumeroExamePersonalizado,
      imprimirProtocoloEntrega,
      agruparLaudos
    } = this.state;

    return (
      <ConfiguracoesGeraisPage
        altura={this.props.altura}
        nomeNotas={this.state.nomeNotas}
        alterarNomeNotas={this.alterarNomeNotas.bind(this)}
        switchValor={switchValor}
        ordenacao={ordenacao}
        posicaoSigla={posicaoSigla}
        posicaoSequencia={posicaoSequencia}
        posicaoAno={posicaoAno}
        valorAno={valorAno}
        posicaoSeparador={posicaoSeparador}
        valorSeparador={valorSeparador}
        posicoesJaSelecionadas={posicoesJaSelecionadas}
        exemploNumeroExamePersonalizado={exemploNumeroExamePersonalizado
          .toString()
          .replaceAll(',', '')}
        imprimirProtocoloEntrega={imprimirProtocoloEntrega}
        agruparLaudos={agruparLaudos}
        onChangeSelect={this.onChangeSelect.bind(this)}
        onChangeInput={this.onChangeInput.bind(this)}
        zerarCampos={this.zerarCampos.bind(this)}
        toggleSwitch={this.toggleSwitch.bind(this)}
        gravarConfiguracoesGerais={this.gravarConfiguracoesGerais.bind(this)}
        switchValorImprimirProtocolo={this.switchValorImprimirProtocolo.bind(
          this
        )}
        switchAgruparLaudo={this.switchAgruparLaudo.bind(this)}
      />
    );
  }

  componentDidMount () {
    let {
      posicaoSigla,
      posicaoSequencia,
      posicaoAno,
      valorAno,
      posicaoSeparador,
      valorSeparador,
      ordenacao
    } = this.state;

    if (
      !posicaoSigla &&
      !posicaoSequencia &&
      !posicaoAno &&
      valorAno !== null &&
      !posicaoSeparador &&
      !valorSeparador
    ) {
      this.props.commonActions.showFadeCarregando(true);
      ConfiguracaoApi.getConfiguracaoGeral().then(res => {
        let posicoesJaSelecionadas = [];
        let exemploNumeroExamePersonalizado = [];

        if (res.sigla_Nrexame_Personalizado !== null) {
          posicoesJaSelecionadas.push(
            res.sigla_Nrexame_Personalizado.toString()
          );
          exemploNumeroExamePersonalizado[res.sigla_Nrexame_Personalizado] =
            'AP';
        }

        if (res.sequence_Nrexame_Personalizado !== null) {
          posicoesJaSelecionadas.push(
            res.sequence_Nrexame_Personalizado.toString()
          );
          exemploNumeroExamePersonalizado[res.sequence_Nrexame_Personalizado] =
            '001';
        }

        if (res.ano_Nrexame_Personalizado !== null) {
          posicoesJaSelecionadas.push(res.ano_Nrexame_Personalizado.toString());
          exemploNumeroExamePersonalizado[res.ano_Nrexame_Personalizado] =
            res.ano_Vigente_Personalizado;
        }

        if (res.separador_Exame_Personalizado !== null) {
          posicoesJaSelecionadas.push(
            res.separador_Exame_Personalizado.toString()
          );
          exemploNumeroExamePersonalizado[res.separador_Exame_Personalizado] =
            res.separador_Personalizado;
        }

        this.setState({
          posicaoSigla: ordenacao[res.sigla_Nrexame_Personalizado],
          posicaoSequencia: ordenacao[res.sequence_Nrexame_Personalizado],
          posicaoAno: ordenacao[res.ano_Nrexame_Personalizado],
          valorAno: res.ano_Vigente_Personalizado || '',
          posicaoSeparador: ordenacao[res.separador_Exame_Personalizado],
          valorSeparador: res.separador_Personalizado || '',
          switchValor: res.nrexame_Personalizado,
          posicoesJaSelecionadas: posicoesJaSelecionadas,
          exemploNumeroExamePersonalizado: exemploNumeroExamePersonalizado,
          imprimirProtocoloEntrega: res.sn_Imprimir_Protocolo_Entrega,
          agruparLaudos: res.sn_Laudos_Agrupados,
          nomeNotas: res.nomeExibicaoEtapaNotas
        });

        this.props.commonActions.showFadeCarregando(false);
      });
    }
  }

  onChangeSelect (name, ele) {
    let state = { ...this.state };
    state[name] = ele;

    let posicoesJaSelecionadas = [];

    if (!!state.posicaoSigla) {
      posicoesJaSelecionadas.push(state.posicaoSigla.value);
    }

    if (!!state.posicaoSequencia) {
      posicoesJaSelecionadas.push(state.posicaoSequencia.value);
    }

    if (!!state.posicaoAno) {
      posicoesJaSelecionadas.push(state.posicaoAno.value);
    }

    if (!!state.posicaoSeparador) {
      posicoesJaSelecionadas.push(state.posicaoSeparador.value);
    }

    let exemploNumeroExamePersonalizado = [
      ...this.state.exemploNumeroExamePersonalizado
    ];
    exemploNumeroExamePersonalizado[+ele.value] =
      name === 'posicaoSigla'
        ? 'AP'
        : name === 'posicaoSequencia'
        ? '001'
        : name === 'posicaoAno'
        ? state.valorAno
        : name === 'posicaoSeparador'
        ? state.valorSeparador
        : '';

    state.posicoesJaSelecionadas = posicoesJaSelecionadas;
    state.exemploNumeroExamePersonalizado = exemploNumeroExamePersonalizado;

    this.setState(state);
  }

  onChangeInput (name, valor) {
    if (name === 'valorAno') {
      if (/^[0-9]{0,4}$/.test(valor)) {
        this.setState({
          [name]: valor
        });
      }
    } else {
      if (valor.length <= 1) {
        this.setState({
          [name]: valor
        });
      }
    }
  }

  zerarCampos () {
    this.setState({
      posicaoSigla: null,
      posicaoSequencia: null,
      posicaoAno: null,
      valorAno: '',
      posicaoSeparador: null,
      valorSeparador: '',
      posicoesJaSelecionadas: [],
      exemploNumeroExamePersonalizado: []
    });
  }

  toggleSwitch () {
    this.setState(state => ({
      switchValor: !state.switchValor
    }));
  }

  gravarConfiguracoesGerais () {
    let {
      posicaoSigla,
      posicaoSequencia,
      posicaoAno,
      valorAno,
      posicaoSeparador,
      valorSeparador,
      switchValor,
      imprimirProtocoloEntrega,
      agruparLaudos,
      nomeNotas
    } = this.state;

    if (
      !switchValor ||
      (!!posicaoSigla &&
        !!posicaoSequencia &&
        !!posicaoAno &&
        !!valorAno &&
        !!posicaoSeparador &&
        !!valorSeparador)
    ) {
      if (switchValor && !parseInt(valorAno)) {
        this.props.commonActions.showAlerta(
          'erro',
          'O ano deve ser numérico',
          2500,
          '500px'
        );
      } else {
        let configuracoes = {
          sigla_nrexame_personalizado: posicaoSigla && +posicaoSigla.value,
          sequence_nrexame_personalizado:
            posicaoSequencia && +posicaoSequencia.value,
          ano_nrexame_personalizado: posicaoAno && +posicaoAno.value,
          separador_exame_personalizado:
            posicaoSeparador && +posicaoSeparador.value,
          nrexame_personalizado: switchValor,
          separador_Personalizado: valorSeparador,
          ano_Vigente_Personalizado: valorAno,
          sn_Imprimir_Protocolo_Entrega: imprimirProtocoloEntrega,
          sn_Laudos_Agrupados: agruparLaudos,
          nomeExibicaoEtapaNotas: nomeNotas
        };

        this.props.commonActions.showFadeCarregando(true);

        ConfiguracaoApi.gravarConfiguracaoGeral(configuracoes).then(
          response => {
            this.props.commonActions.showFadeCarregando(false);
            this.props.commonActions.showAlerta(
              'sucesso',
              'Configurações alteradas com sucesso',
              2500,
              '500px'
            );
          }
        );
      }
    } else {
      this.props.commonActions.showAlerta(
        'erro',
        'O preenchimento de todos os campos é obrigatório',
        2500,
        '500px'
      );
    }
  }

  switchValorImprimirProtocolo = () =>
    this.setState(state => ({
      imprimirProtocoloEntrega:
        state.imprimirProtocoloEntrega === 'S' ? 'N' : 'S'
    }));

  switchAgruparLaudo = () =>
    this.setState(state => ({
      agruparLaudos: state.agruparLaudos === 'S' ? 'N' : 'S'
    }));
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfiguracoesGeraisContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/geral/geral.container.js